import { useQuery } from "@tanstack/react-query";
import { AlertCircle } from "lucide-react";
import SignInActivityItem from "@/components/sign-in-activity-item";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from "@/components/ui/empty";
import { trpc, withErrorToast } from "@/utils/trpc";

export default function SignInHistory() {
  return <SignInHistorySection />;
}

export function SignInHistorySection() {
  const recentSignIns = useQuery(
    withErrorToast(trpc.getRecentSignIns.queryOptions())
  );

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle>Sign-in activity</CardTitle>
        <CardDescription>
          Review your recent site access and sign-in history.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {recentSignIns.isError ? (
          <Alert variant="destructive">
            <AlertCircle />
            <AlertTitle>Failed to load sign-in activity</AlertTitle>
            <AlertDescription>
              Could not retrieve your sign-in history. Please try again.
            </AlertDescription>
          </Alert>
        ) : recentSignIns.data && recentSignIns.data.length > 0 ? (
          <div className="space-y-3">
            {recentSignIns.data.map((signIn) => (
              <div key={signIn.id} className="rounded-lg border p-3">
                <SignInActivityItem
                  title={signIn.siteName}
                  subtitle={signIn.siteAddress}
                  signInTime={signIn.signInTime}
                  signOutTime={signIn.signOutTime}
                  method={signIn.method}
                  flagged={signIn.flagged}
                  distanceFromSite={signIn.distanceFromSite}
                />
              </div>
            ))}
          </div>
        ) : (
          <Empty>
            <EmptyHeader>
              <EmptyTitle>No recent activity found</EmptyTitle>
              <EmptyDescription>
                Your recent activity will appear here once you start signing in
                at your assigned sites.
              </EmptyDescription>
            </EmptyHeader>
          </Empty>
        )}
      </CardContent>
    </Card>
  );
}
